module.exports = __webpack_public_path__ + "static/media/waves-min.0b4d7fb9.jpg";